import type { CompanyWithProfileApi } from '@/types/api/companies';
import { useModeAwareQuery } from './useModeAwareQuery';
import { useApi } from './useApi';

export function useCompanyWithProfile(companyId: number | string | undefined) {
  const { apiGet } = useApi();
  const id = companyId ? Number(companyId) : undefined;

  return useModeAwareQuery<CompanyWithProfileApi | null, Error>(
    ['company-with-profile', id],
    ({ signal }) => apiGet<CompanyWithProfileApi>(`/api/v1/company/${id}`, undefined, signal),
    null,
    { enabled: !!id }
  );
}
